var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ReactComponent as PhoneSVG } from '../../assets/images/global/phone.svg';
import { ReactComponent as LocaleSVG } from '../../assets/images/global/locale.svg';
import CardExamEstablishmentInformationAPI from './card-exam-establishment-information-api';
import './card-exam-establishment-information.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let CardExamsEstablishmentInformation = class CardExamsEstablishmentInformation extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            visible: true,
            width: 12
        };
        this.onClickExamEstab = () => {
            const { onClickExamEstab } = this.props;
            if (isFunction(onClickExamEstab)) {
                onClickExamEstab(new ClickEvent({
                    value: {
                        onClickExamEstab
                    }
                }));
            }
        };
    }
    render() {
        const { dsEndereco, nrEndereco, dsEstado, dsMunicipio, dsRazaoSocial, nrDdiTelefone, nrDddTelefone, nrTelefone } = this.props;
        return (React.createElement(Card, { onClick: () => this.onClickExamEstab(), width: 12, className: 'card-exam-establishment-information', selectionType: SelectionType.SINGLE, uuid: "cc12ce28-962b-4bd0-9d7c-22ddf6707e3c" },
            React.createElement("div", { className: 'info-label' }, dsRazaoSocial),
            React.createElement("div", { className: "info-content" },
                React.createElement("div", { className: 'info' },
                    this.getLocaleSVG(),
                    React.createElement("div", { className: 'local' }, `${dsEndereco}, ${nrEndereco} ${dsMunicipio}, ${dsEstado}`)),
                React.createElement("div", { className: 'info' },
                    this.getPhoneSVG(),
                    React.createElement("div", { className: 'phone' },
                        React.createElement("b", null, this.validationPhone(nrTelefone, nrDddTelefone, nrDdiTelefone)))))));
    }
    getPhoneSVG() {
        return (React.createElement("div", { className: 'icon' },
            React.createElement(PhoneSVG, { className: 'icon-info' })));
    }
    getLocaleSVG() {
        return (React.createElement("div", { className: 'icon' },
            React.createElement(LocaleSVG, { className: 'icon-info' })));
    }
    validationPhone(nrTelefone, nrDddTelefone, nrDdiTelefone) {
        if (nrTelefone === undefined) {
            return MessageService.translate('result.no.information');
        }
        if (nrDddTelefone === undefined) {
            return nrTelefone;
        }
        if (nrDdiTelefone === undefined) {
            return nrDddTelefone + ' ' + nrTelefone;
        }
        return nrDdiTelefone + ' ' + nrDddTelefone + ' ' + nrTelefone;
    }
};
CardExamsEstablishmentInformation.propTypes = {
    onClick: eventListener,
    dsEndereco: string,
    nrEndereco: string,
    dsEstado: string,
    dsMunicipio: string,
    dsBarrio: string,
    cdCep: string,
    dsRazaoSocial: string,
    nrDdiTelefone: string,
    nrDddTelefone: string,
    nrTelefone: string,
    dsEmail: string
};
CardExamsEstablishmentInformation = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: CardExamEstablishmentInformationAPI })
], CardExamsEstablishmentInformation);
export default CardExamsEstablishmentInformation;
//# sourceMappingURL=card-exam-establishment-information.js.map